import _ from "lodash";

// components
import { Button } from "antd";
import { BugOutlined, FlagOutlined } from "@ant-design/icons";
import IconLink from "~/components/app/IconLink";
import Icon from "@ant-design/icons/lib/components/Icon";
import PostActionButton from "~/components/post/PostActionButton";
import BugIcon from "~/components/app/BugIcon";

// redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { showAppModal, setReport } from "~/redux/actions/app";

const SiteReportAction = (props) => {
  const { contentType, contentId } = props;

  const handleReportCreate = () => {
    if (props.token) {
      props.setReport({ contentType, contentId });
      props.showAppModal("ReportModal");
    } else {
      props.showAppModal("PhoneSigninModal");
    }
  };
  if (contentType === "Comment") {
    return (
      <span>
        <IconLink
          icon={<BugOutlined />}
          text="举报"
          onClick={handleReportCreate}
        />
      </span>
    );
  } else if (contentType === "User") {
    return (
      <Button type="link" onClick={handleReportCreate}>
        举报
      </Button>
    );
  } else if (contentType === "Group") {
    return (
      <a onClick={handleReportCreate} className="text-primary"><FlagOutlined /> 举报</a>
    );
  } else if (contentType === "Post") {
    return (
      <PostActionButton
        onClick={handleReportCreate}
        text="举报"
        icon={<Icon component={BugIcon} style={{ fontSize: "20px" }} />}
      />
    );
  }
};

const mapStateToProps = (state) => ({
  token: state.user.token,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppModal,
      setReport,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteReportAction);
